export default __webpack_public_path__ + "static/blockchain-61be70e275ef19c2bb590670647b5629.svg";